import { render, staticRenderFns } from "./orderEnterIndex.vue?vue&type=template&id=6634fd60&scoped=true&"
import script from "./orderEnterIndex.vue?vue&type=script&lang=js&"
export * from "./orderEnterIndex.vue?vue&type=script&lang=js&"
import style0 from "./index.css?vue&type=style&index=0&id=6634fd60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6634fd60",
  null
  
)

export default component.exports